import { decode } from 'query-params'

/**
 * Get environment from url
 */
export function getEnvironment() {
  const route = window.location.hash.slice(1)
  const index = route.indexOf('?')
  const queryParams = index !== -1 ? decode(route.slice(index + 1)) : {}
  const env = queryParams.environment ? queryParams.environment.toLowerCase() : ''

  return env === 'production'
    ? 'production'
    : env.indexOf('local') === 0 || window.location.host.includes('localhost') // 'local' or 'localhost'
    ? 'localhost'
    : env.indexOf('dev') === 0 // 'dev', 'develop' or 'development'
    ? 'development'
    : window.location.host.includes('terminalplanner.teqplay.nl')
    ? 'production'
    : 'development'
}
